// extracted by mini-css-extract-plugin
export var closeButton = "_n4-2";
export var closeButtonIcon = "_n4-3";
export var lightboxContent = "_n4-1";
export var lightboxOverlay = "_n4-0";